import React from 'react'

import { Button, Icon } from '../../..'
import { useTranslation } from '../../../../utils/providers'

function OutOfStockButton() {
  const { t } = useTranslation()
  const title = t('OUT_OF_STOCK')

  return (
    <Button
      variant="secondary"
      className="product-action-bubble"
      disabled={true}
      title={title}
      aria-label={title}
    >
      <Icon symbol="cf-cart-o" className="font-size-base" />
    </Button>
  )
}

export default OutOfStockButton
